import axios from "./axiosConfig";
import Cookies from 'js-cookie';

const basePath = process.env.NODE_ENV === "production" ? "/api/" : "";

// const getAdminBoard = () => {
//     return axios.get(API_URL + 'v1/APIProductCategory', { headers: { Authorization: token} });
// };

const getUser = () => {
  return axios
    .get("/Account/GetUser", {
      baseURL: basePath,
    })
    .then((response) => {
      return response.data;
    });
};

// const getPartner = (token) => {
//     return axios.get(API_URL + 'v1/Partner', { headers: { Authorization: token} })
//     .then((response) => {
//       return response.data;
//     });
// }

const getLoginAccountList = async (id) => {
  return axios
  .get("/v1/UserPartner/" + id, {
    baseURL: basePath,
  })
  .then((response) => {
    return response.data;
  })
}

const updateUser = (userId, userName, mobile, email) => {
  return axios.post(
    "/Account/Update-IdentityUser",
    {
      userId,
      userName,
      email,
      mobile,
    },
    { 
      baseURL: basePath,
    }
  );
};

const getAPIAccount = async (id) => {
  return axios
    .get("/v1/APIAccount/" + id, {
      baseURL: basePath,
    })
    .then((response) => {
      return response.data;
    });
};

const getCategory = (PartnerId, categoryId) => {
  return axios
    .get("/v1/APIProductCategory/Id?partnerId=" + PartnerId + "&categoryId=" + categoryId, {
      baseURL: basePath,
    })
    .then((response) => {
      return response.data;
    });
};

const addAPIAccount = (
  partnerId,
  apiUserName,
  apiKey,
  productAccount,
  agentId,
  agentType
) => {
  var StringPartnerId = partnerId;
  return axios
    .post(
      "v1/APIAccount",
      {
        StringPartnerId,
        apiUserName,
        apiKey,
        productAccount,
        agentId,
        agentType,
      },
      { 
        baseURL: basePath,
      }
    )
    .then((response) => {
      var key = apiKey;
      axios.post(
        "v1/OnlineEtiqa/APIAccount",
        {
          apiUserName,
          key,
          agentId,
        },
        { 
          baseURL: basePath,
        }
      );
      return response;
    });
};

const updateAPIAccount = (id, apiUserName, apiKey, productAccount) => {
  return axios.post(
    "v1/APIAccount/Update/" + id,
    {
      id,
      apiUserName,
      apiKey,
      productAccount,
    },
    { 
      baseURL: basePath,
    }
  );
};

const deleteAPIAccount = (id) => {
  return axios.post(
    "v1/APIAccount/delete/" + id,
    {
      id,
    },
    { 
      baseURL: basePath,
    }
  );
};

const getAPIProductById = async (id) => {
  return await axios
    .get("v1/APIProduct/" + id, {
      baseURL: basePath,
    })
    .then((response) => {
      return response.data;
    });
};

const getAPIPortalLogInCategory = async (
  PartnerId,
  StartDate,
  EndDate
) => {
  return await axios
    .post(
      "v1/APIPortalLog/",
      { PartnerId, StartDate, EndDate },
      { 
        baseURL: basePath,
      }
    )
    .then((response) => {
      return response.data;
    });
};

const getAPIPortalLogInAccount = async (
  APIAccountId,
  StartDate,
  EndDate
) => {
  return await axios
    .post(
      "v1/APIPortalLog/APIAccount/",
      { APIAccountId, StartDate, EndDate },
      { 
        baseURL: basePath,
      }
    )
    .then((response) => {
      return response.data;
    });
};

//dl pdf function
const getPdf = async (categoryId, fileName) => {
  return await axios
    .get("v1/APIProductCategory/GeneratePDF/" + categoryId + "/" + fileName
    , {
      baseURL: basePath,
      responseType: 'blob', // important
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName + ".pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();
      return response.data;
    });
};

export default {
  //getAdminBoard,
  getUser,
  getLoginAccountList,
  //getPartner,
  updateUser,
  getAPIAccount,
  getCategory,
  addAPIAccount,
  updateAPIAccount,
  deleteAPIAccount,
  getAPIProductById,
  getAPIPortalLogInCategory,
  getAPIPortalLogInAccount,
  getPdf
};
